import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState: boolean = false

export default handleActions<boolean, any>(
  {
    [rawActions.saveFormRecord.toString()](state, action) {
      return true
    },
    [combineActions(rawActions.saveFormRecord.success, rawActions.saveFormRecord.failed).toString()](state, action) {
      return defaultState
    },
    [rawActions.resetFormsState.toString()](state, action) {
      return defaultState
    },
  },
  defaultState
)
